<div id="help_menu">
  <sh-icon icon="help" size="m" button aria-label="Help"></sh-icon>
  <sh-text size="body-2" class="text-setting" color="primary">{{
    'label.help' | translate
  }}</sh-text>
</div>
<sh-popover
  id="popOver"
  class="helpAndSupportPopOver"
  #userPopOver
  target="help_menu"
  position="bottom"
  style="width: fit-content; margin-top: 20px"
  *ngIf="userService.isAuthorized$ | async"
>
  <div>
    <sh-text size="super-header">{{ 'label.support' | translate }}</sh-text>
    <sh-list flat integrated>
      <sh-list-item
        *ngIf="isWhatsNewEnabled"
        (click)="showWhatsNewModal()"
        class="WhatsNewModalButton"
        clickable
        divider="none"
        >{{ 'label.whatsNew' | translate }}</sh-list-item
      >
      <sh-list-item
        (click)="routeToReleaseNotes()"
        class="ReleaseNotesButton"
        clickable
        divider="none"
        >{{ 'label.releaseNotes' | translate }}</sh-list-item
      >

      @if (announcementService.hiddenAnnouncement$ | async; as announcement) {
        <sh-list-item
          (click)="announcementService.closeAnnouncement()"
          class="ReleaseNotesButton"
          clickable
          divider="none"
          >{{ 'label.latestAnnouncement' | translate }} ({{
            announcement.creationTimeOrLabel
              | localizedDate: 'longFormat' : announcement.creationTimeOrLabel
          }})</sh-list-item
        >
      }
    </sh-list>

    <sh-divider></sh-divider>
    <sh-text size="super-header">{{ 'label.getHelp' | translate }}</sh-text>
    <div style="max-width: 300px; margin-top: 0.2rem; margin-bottom: 0.5rem">
      {{ 'message.getHelp' | translate }}
    </div>
    <div>
      <a
        href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI0MTgyOTEzMDI0MCJ9"
        target="_blank"
        style="text-decoration: none"
      >
        <sh-icon
          icon="url('assets/engage.png')"
          style="display: inline-block; margin-right: 0.5rem"
        ></sh-icon
      ></a>
      <a
        href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI0MTgyOTEzMDI0MCJ9"
        target="_blank"
        style="color: var(--text-primary)"
        >{{ 'label.getHelpLink' | translate }}
      </a>
    </div>
  </div>
</sh-popover>
